export default "__VITE_ASSET__BMrG3Xgd__"